import { render, staticRenderFns } from "./PlacementsEndComponentCapabilitiesItem.vue?vue&type=template&id=0d5f4ff7&"
import script from "./PlacementsEndComponentCapabilitiesItem.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentCapabilitiesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports